export const SET_MARKER = 'SET_MARKER';

export const setMarker = ({ id, marker }) => (dispatch) => dispatch({
  type: SET_MARKER,
  id, marker
});
